import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Checkbox } from "primereact/checkbox";
import Autocomplete from "@mui/material/Autocomplete";
import { AlertContext } from "../../../context/AlertContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { Link, Redirect } from "react-router-dom";
import Spinner from "../Spinner";
import { AuthContext } from "../../../context/AuthContext";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "../../../assets/css/DataTableDemo.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "../../../assets/css/PrimeGrid.css";
import "../../../assets/css/CierreDialog.css";
import { Tag } from "primereact/tag";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import CloseIcon from "@mui/icons-material/Close";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import ConsultaServicio from "./ConsultaServicio";
import NotasServicio from "./NotasServicio";
import { ScrollPanel } from "primereact/scrollpanel";
import hcOffcanvasNav from "hc-offcanvas-nav";
import $ from "jquery";
import { saveAs } from "file-saver";
import { Navigate, useNavigate } from "react-router-dom";
import Barra from "../Barra";
import { ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { getBrand, createBrandTheme } from "../../../theme/brand";
import PantallaHeader from "../common/PantallaHeader";

export default function Eventos(props) {
  //const classes = useStyles();
  const [globalFilter, setGlobalFilter] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const exportColumns = [
    { title: "Llegada", dataKey: "llegada" },
    { title: "Nombre", dataKey: "afiliadoNombre" },
    { title: "Domicilio", dataKey: "domicilioOrigen" },
  ];

  const [visible, setVisible] = useState(false);
  const [visibleModificar, setVisibleModificar] = useState(false);
  const [selectedRowEvento, setSelectedRowEvento] = useState(null);
  const toast = useRef(null);
  let navigate = useNavigate();

  //Context

  const serviciosContext = useContext(ServiciosContext);
  const {
    eventos,
    direcciones,
    obtenerEventos,
    obtenerDirecciones,
    guardarServicio,
    eliminarEventoProgramado,
    modificarEventoPendiente,
    obtenerNotasPendientes,
  } = serviciosContext;

  const alertContext = useContext(AlertContext);
  const { mensajeAlerta } = alertContext;

  const authContext = useContext(AuthContext);
  const { state, usuarioAutenticado } = authContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { statusAcceso, configuracion, obtenerAcceso } = configuracionContext;

  const theme = createBrandTheme(getBrand(configuracion));

  useEffect(() => {
    if (state.usuario) {
      obtenerAcceso({ usuarioId: state.usuario.id, layout: "Eventos" });
    }
    obtenerEventos();
  }, [state.id]);

  setTimeout(() => {
    if (statusAcceso === 400) {
      accesoDenegado();
    }
  }, 3000);

  const exitClick = (e) => {
    navigate(`/`);
  };

  const onHide = (e) => {
    setVisible(false);
  };

  const accesoDenegado = () => {
    mensajeAlerta(
      "Accesos",
      "No tiene permiso para acceder a esta pantalla !.",
      "error"
    );
    exitClick();
    return;
  };

  const idTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID</span>
        {rowData.id}
      </Fragment>
    );
  };

  const llegadaTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Llegada</span>
        {rowData.llegada}
      </Fragment>
    );
  };

  const afiliadoIdTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">ID Afiliado</span>
        {rowData.afiliadoId}
      </Fragment>
    );
  };

  const afiliadoNombreTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Nombre</span>
        {rowData.afiliadoNombre}
      </Fragment>
    );
  };

  const domicilioOrigenTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Domicilio Origen</span>
        {rowData.domicilioOrigen}
      </Fragment>
    );
  };

  const domicilioDestinoTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Domicilio Destino</span>
        {rowData.domicilioDestino}
      </Fragment>
    );
  };

  const afiliadoTitularTemplate = (rowData) => {
    return (
      <Fragment>
        <span className="p-column-title">Titular</span>
        {rowData.afiliadoTitular}
      </Fragment>
    );
  };

  const exportPdf = () => {
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const doc = new jsPDF.default(0, 0);
        doc.autoTable(exportColumns, eventos);
        doc.save("eventos.pdf");
      });
    });
  };

  const exportExcel = () => {
    import("xlsx").then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(eventos);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      saveAsExcelFile(excelBuffer, "eventos");
    });
  };

  const saveAsExcelFile = (buffer, fileName) => {
    import("file-saver").then((FileSaver) => {
      let EXCEL_TYPE =
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
      let EXCEL_EXTENSION = ".xlsx";
      const data = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  };

  const actionBodyTemplate = (rowData) => {
    return (
      <Fragment>
        <Button
          style={{
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
          }}
          icon="pi pi-search"
          className="p-button-success p-button-text"
          onClick={() => {
            consultaSocio(rowData);
            obtenerNotasPendientes({ servicioId: rowData.id });
          }}
          tooltip="Datos del Evento"
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
            className: "tooltip",
          }}
        />
        <Button
          style={{
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
          }}
          icon="pi pi-replay"
          className="p-button-secondary p-button-text"
          onClick={() => {
            setSelectedRow(rowData);
            modificarEvento(rowData);
          }}
          tooltip="Modificar Evento"
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
            className: "tooltip",
          }}
        />
        <Button
          style={{
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
          }}
          icon="pi pi-trash"
          className="p-button-danger p-button-text"
          onClick={() => confirm(rowData)}
          tooltip="Eliminar Evento"
          tooltipOptions={{
            position: "bottom",
            mouseTrack: true,
            mouseTrackTop: 15,
            className: "tooltip",
          }}
        />
      </Fragment>
    );
  };

  const consultaSocio = (rowData) => {
    guardarServicio({
      ...rowData,
      origen: "pendientes",
    });
    setVisible(true);
  };

  const renderHeader = () => {
    return (
      <div>
        <Tag value="Datos del Evento"></Tag>
      </div>
    );
  };

  const renderFooter = (name) => {
    return (
      <div>
        <Button label="Cerrar" icon="pi pi-times" onClick={() => onHide()} />
      </div>
    );
  };

  const confirm = (rowData) => {
    confirmDialog({
      message: "Esta seguro de eliminar el evento programado ?",
      header: "Confirmación",
      icon: "pi pi-exclamation-triangle",
      accept: () => acceptFunc(rowData),
    });
  };

  const acceptFunc = (rowData) => {
    eliminarEventoProgramado({
      id: rowData.id,
      usuario: state.usuario.usuario,
    });

    setTimeout(() => {
      obtenerEventos();
    }, 2000);
  };

  const modificarEvento = (data) => {
    let a_date = data.llegada.substring(0, 10);
    let a_time = data.llegada.substring(11, 16);
    let newdate = a_date.split("/").reverse().join("-");
    let newDateLlegada = newdate + "T" + a_time;

    setSelectedRowEvento({
      id: data.id,
      eventoId: data.eventoId,
      llegada: newDateLlegada,
      domicilioOrigen: data.domicilioOrigen,
      provincia: "Buenos Aires",
      latOrigen: data.lat,
      lonOrigen: data.lon,
      duracion: data.duracion,
      cantidadMoviles: data.cantidadMoviles,
      dotacion: data.dotacion,
      tipoEvento: data.tipoEvento,
      responsable: data.responsable,
      contacto: data.contacto,
      cantidadPersonas: data.cantidadPersonas,
      descripcion: data.descripcion,
    });
    setVisibleModificar(true);
  };

  const handleInputBlurOrigen = () => {
    if (!selectedRowEvento) return;
    obtenerDirecciones({
      domicilio: selectedRowEvento.domicilioOrigen
        ? selectedRowEvento.domicilioOrigen.toLowerCase()
        : "",
      provincia: selectedRowEvento.provincia
        ? selectedRowEvento.provincia.toLowerCase()
        : "buenos aires",
    });
  };

  const handleCloseModificar = () => {
    setSelectedRowEvento(null);
    setVisibleModificar(false);
  };

  const handleModificar = () => {
    if (!selectedRowEvento || !selectedRowEvento.llegada) {
      toast.current.show({
        severity: "warn",
        summary: "Llegada",
        detail: `Debe indicar la llegada.`,
        life: 3000,
      });
      return;
    }

    if (
      !selectedRowEvento.domicilioOrigen ||
      selectedRowEvento.domicilioOrigen === ""
    ) {
      toast.current.show({
        severity: "warn",
        summary: "El domicilio de origen es necesario !.",
        life: 3000,
      });
      return;
    }

    modificarEventoPendiente({
      id: selectedRowEvento.id,
      eventoId: selectedRowEvento.eventoId,
      origen: selectedRowEvento.origenGeo
        ? selectedRowEvento.origenGeo
        : selectedRowEvento.domicilioOrigen,
      latOrigen: selectedRowEvento.latOrigen,
      lonOrigen: selectedRowEvento.lonOrigen,
      llegada: selectedRowEvento.llegada,
      duracion: selectedRowEvento.duracion,
      cantidadMoviles: selectedRowEvento.cantidadMoviles,
      dotacion: selectedRowEvento.dotacion,
      tipoEvento: selectedRowEvento.tipoEvento,
      responsable: selectedRowEvento.responsable,
      contacto: selectedRowEvento.contacto,
      cantidadPersonas: selectedRowEvento.cantidadPersonas,
      descripcion: selectedRowEvento.descripcion,
    });

    handleCloseModificar();
    setTimeout(() => {
      obtenerEventos();
    }, 1000);
  };

  const renderHeaderModificar = () => {
    return (
      <div>
        <Tag value="Modificación del Evento"></Tag>
      </div>
    );
  };

  const renderFooterModificar = () => {
    return (
      <div>
        <Button
          label="Confirmar"
          icon="pi pi-check"
          onClick={() => handleModificar()}
          className="p-button-text"
          autoFocus
        />
        <Button
          label="Salir"
          icon="pi pi-times"
          onClick={() => handleCloseModificar()}
          className="p-button-text"
        />
      </div>
    );
  };

  //console.log(eventos);

  return (
    <Fragment>
      <Barra />
      <Toast ref={toast} />
      <ConfirmDialog />
      {statusAcceso === 0 || statusAcceso === 400 ? <Spinner /> : null}
      {statusAcceso === 200 ? (
        <ThemeProvider theme={theme}>
          <Box sx={{ px: { xs: 1, sm: 2 }, pb: 3 }}>
            <PantallaHeader
              icono={<EventOutlinedIcon />}
              titulo="Eventos"
              count={eventos ? eventos.length : null}
              onBuscar={(v) => setGlobalFilter(v)}
              acciones={[
                {
                  label: "Excel",
                  icon: <FileDownloadOutlinedIcon />,
                  color: "success",
                  onClick: exportExcel,
                },
                {
                  label: "PDF",
                  icon: <PictureAsPdfOutlinedIcon />,
                  color: "error",
                  onClick: exportPdf,
                },
                {
                  label: "Cerrar",
                  variant: "text",
                  color: "inherit",
                  icon: <CloseIcon />,
                  onClick: exitClick,
                },
              ]}
            />
            <Paper
              elevation={0}
              sx={{
                borderRadius: 2,
                overflow: "hidden",
                "& .p-datatable-wrapper": { overflowX: "auto" },
              }}
            >
                <DataTable
                  value={eventos}
                  selection={selectedRow}
                  onSelectionChange={(e) => setSelectedRow(e.value)}
                  selectionMode="single"
                  dataKey="id"
                  className="p-datatable-sm p-datatable-striped p-datatable-responsive-demo mito-grid"
                  style={{ fontSize: "small" }}
                  globalFilter={globalFilter}
                  emptyMessage="No hay datos."
                  paginator
                  paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                  currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                  rows={10}
                  rowsPerPageOptions={[10, 20, 50]}
                  //paginatorLeft={paginatorLeft}
                  //paginatorRight={paginatorRight}
                >
                  <Column
                    field="id"
                    header="ID"
                    body={idTemplate}
                    sortable
                    //style={{ display: "none" }}
                  ></Column>
                  <Column
                    field="llegada"
                    header="Llegada"
                    body={llegadaTemplate}
                    sortable
                    //style={{ width: "10%" }}
                  ></Column>
                  <Column
                    field="afiliadoId"
                    header="ID Afiliado"
                    body={afiliadoIdTemplate}
                    sortable
                  ></Column>
                  <Column
                    field="afiliadoNombre"
                    header="Nombre"
                    body={afiliadoNombreTemplate}
                    sortable
                  ></Column>
                  <Column
                    field="domicilioOrigen"
                    header="Domicilio Origen"
                    body={domicilioOrigenTemplate}
                    sortable
                    //style={{ width: "20%" }}
                  ></Column>
                  <Column
                    field="Titular"
                    header="Titular"
                    body={afiliadoTitularTemplate}
                    sortable
                    //style={{ width: "15%" }}
                  ></Column>
                  <Column
                    className="colBotones"
                    body={actionBodyTemplate}
                    //style={{ width: "8%" }}
                  ></Column>
                </DataTable>
            </Paper>
          </Box>
        </ThemeProvider>
      ) : (
        <Spinner />
      )}
      <Grid item xs={12} sm={12}></Grid>
      <div className="dialog-demo">
        <div className="card">
          <Dialog
            header={renderHeader}
            className="cierre-dialog"
            visible={visible}
            icon="pi pi-external-link"
            closable={true}
            onHide={() => onHide()}
            //footer={renderFooter()}
            breakpoints={{ "960px": "75vw" }}
            style={{
              width: "100vw",
              paddingBottom: "0",
              overflowY: "visible",
            }}
            position="top-right"
          >
            <Grid container spacing={1} style={{ padding: "0" }}>
              <Grid item xs={12} md={8}>
                <ScrollPanel style={{ width: "100%", height: "100%" }}>
                  <div style={{ padding: "0em", lineHeight: "1.5" }}>
                    <ConsultaServicio />
                  </div>
                </ScrollPanel>
              </Grid>
              <Grid item xs={12} md={4}>
                <ScrollPanel
                  style={{ width: "100%", height: "100%" }}
                  className="custombar1"
                >
                  <div style={{ padding: "0em", lineHeight: "1.5" }}>
                    <NotasServicio />
                  </div>
                </ScrollPanel>
              </Grid>
            </Grid>
          </Dialog>

          <Dialog
            header={renderHeaderModificar()}
            className="cierre-dialog"
            visible={visibleModificar}
            footer={renderFooterModificar()}
            breakpoints={{ "960px": "75vw" }}
            style={{ width: "60vw", paddingBottom: "0" }}
            closable={false}
          >
            {selectedRowEvento ? (
              <Grid
                container
                spacing={3}
                style={{ padding: "0", marginTop: "1vw" }}
              >
                <Grid item xs={12} md={4}>
                  <TextField
                    id="llegada"
                    label="Llegada"
                    type="datetime-local"
                    fullWidth
                    value={selectedRowEvento.llegada || ""}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        llegada: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={8}>
                  <TextField
                    id="origen"
                    label="Domicilio de origen"
                    value={selectedRowEvento.domicilioOrigen || ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onBlur={handleInputBlurOrigen}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        domicilioOrigen: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <Autocomplete
                    id="origenGeo"
                    fullWidth
                    disablePortal
                    noOptionsText={"No hay opciones"}
                    options={direcciones || []}
                    getOptionLabel={(option) => option.label}
                    openOnFocus={true}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Origen geolocalizado"
                        variant="outlined"
                        size="small"
                      />
                    )}
                    onChange={(event, value) => {
                      if (value) {
                        setSelectedRowEvento({
                          ...selectedRowEvento,
                          origenGeo: value.label,
                          latOrigen: value.lat,
                          lonOrigen: value.lon,
                        });
                      } else {
                        setSelectedRowEvento({
                          ...selectedRowEvento,
                          origenGeo: null,
                        });
                      }
                    }}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    id="tipoEvento"
                    label="Tipo de evento"
                    value={selectedRowEvento.tipoEvento || ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        tipoEvento: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    id="duracion"
                    label="Duración"
                    value={selectedRowEvento.duracion || ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        duracion: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    id="cantidadMoviles"
                    label="Cantidad de móviles"
                    type="number"
                    value={selectedRowEvento.cantidadMoviles ?? ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        cantidadMoviles: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={6} sm={6} md={3}>
                  <TextField
                    id="cantidadPersonas"
                    label="Cantidad de personas"
                    type="number"
                    value={selectedRowEvento.cantidadPersonas ?? ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        cantidadPersonas: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    id="dotacion"
                    label="Dotación"
                    value={selectedRowEvento.dotacion || ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        dotacion: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    id="responsable"
                    label="Responsable"
                    value={selectedRowEvento.responsable || ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        responsable: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <TextField
                    id="contacto"
                    label="Contacto"
                    value={selectedRowEvento.contacto || ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        contacto: e.target.value,
                      })
                    }
                  />
                </Grid>

                <Grid item xs={12} md={12}>
                  <TextField
                    id="descripcion"
                    label="Descripción"
                    value={selectedRowEvento.descripcion || ""}
                    fullWidth
                    multiline
                    minRows={2}
                    variant="outlined"
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    onChange={(e) =>
                      setSelectedRowEvento({
                        ...selectedRowEvento,
                        descripcion: e.target.value,
                      })
                    }
                  />
                </Grid>
              </Grid>
            ) : null}
          </Dialog>
        </div>
      </div>
    </Fragment>
  );
}

/* class="MuiDataGrid-cell MuiDataGrid-cellLeft" */
